import classnames from 'classnames/bind';
import React from 'react';
import { getIcon } from '@uifabric/styling/lib/utilities/icons';
import { SvgIconStylesContext } from './SvgIconStylesContext';
import type { FluentSvgIconProps } from '../schema/FluentSvgIcon.types';

const styles = require('./FluentSvgIcon.scss');
const cx = classnames.bind(styles);

const DEFAULT_ICON_DEFINITION = {
    subset: {
        className: undefined,
    },
    code: undefined,
};

export const FluentSvgIcon = React.forwardRef(
    (props: FluentSvgIconProps, ref?: React.RefObject<any>): JSX.Element => {
        const { icon, iconStyles, iconContainerStyles, ...remainingProps } = props;

        const iconDefinition = getIcon(icon) || DEFAULT_ICON_DEFINITION;

        const stylesContextValue = { iconStyles: cx('svg', iconStyles) };

        return (
            <SvgIconStylesContext.Provider value={stylesContextValue}>
                <i
                    ref={ref}
                    aria-hidden={true}
                    data-icon-name={icon}
                    className={cx('root', iconContainerStyles)}
                    {...remainingProps}>
                    {iconDefinition.code}
                </i>
            </SvgIconStylesContext.Provider>
        );
    }
);
